@if (mapEntry(); as map) {
  <!-- Title and action buttons -->
  <div class="npdc-title">
    <hgroup>
      @if (map.content.preamble) {
        <p>{{ map.content.preamble }}</p>
      }
      <h1>{{ map.content.title }}</h1>
      @if (map.content.subtitle) {
        <p>{{ map.content.subtitle }}</p>
      }
    </hgroup>
    <div class="npdc-title__actions">
      @if (
        authService.user() &&
        (permissions()?.mayUpdate ||
          authService.canInvoke(authService.endpoints.editMapArchiveEntry))
      ) {
        <button class="npdc-toolbar-button" mat-flat-button [routerLink]="'edit'">Edit</button>
        @if (
          authService.user() &&
          (permissions()?.mayDelete ||
            authService.canInvoke(authService.endpoints.deleteMapArchiveEntry))
        ) {
          <button mat-icon-button [matMenuTriggerFor]="optionsMenu" matToolTip="More Actions">
            <mat-icon>more_vert</mat-icon>
          </button>
        }
      }
    </div>
  </div>

  @if (map.content.serie || map.content.mapType || map.content.scales?.length) {
    <p>
      <mat-chip-set>
        @if (map.content.serie) {
          <mat-chip>
            <span title="{{ map.content.serie }}">
              <strong>Series:</strong> {{ map.content.serie }}
            </span>
          </mat-chip>
        }
        @if (map.content.mapType) {
          <mat-chip>
            <span title="{{ map.content.mapType }}">
              <strong>Type:</strong> {{ map.content.mapType }}
            </span>
          </mat-chip>
        }
        @if (map.content.scales && map.content.scales.length) {
          <mat-chip>
            <span title="{{ getScaleList() }}">
              <strong>
                @if (map.content.scales.length === 1) {
                  Scale:
                } @else {
                  Scales:
                }
              </strong>
              {{ getScaleList() }}
            </span>
          </mat-chip>
        }
      </mat-chip-set>
    </p>
  }

  <!-- License Note -->
  @if (shownAsPublicDomain()) {
    <p>
      <strong>Note: </strong>If you want to use this material it's recommended that you check the
      original license with the rules in your jurisdiction. Even when the license is shown as
      'Public Domain Mark 1.0' different conditions might apply in other jurisditctions.
    </p>
  }

  <!-- Options Menu -->

  <mat-menu #optionsMenu>
    <button mat-menu-item (click)="deleteMap()"><mat-icon>delete</mat-icon>Delete</button>
  </mat-menu>

  <!-------------->
  <!-- Contents -->
  <!-------------->

  <!-- Map cards with info -->

  <div class="npdc-card-grid">
    @for (img of this.imageList.value()?.items; track img.id) {
      <mat-card appearance="outlined">
        <a
          mat-card-image
          title="Click for hi-res web preview"
          href="{{ webBaseAddr }}&recordId={{ map.id }}&parentId={{ img.id }}"
          target="_blank"
        >
          <app-card-image
            mat-card-image
            alt="{{ img.title || img.filename }} thumbnail"
            src="{{ thumbBaseAddr }}&recordId={{ map.id }}&parentId={{ img.id }}"
          />
        </a>
        <mat-card-header>
          <mat-card-title>{{ img.title || img.filename }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @if (map.content.scans && map.content.scans[img.id]) {
            <p style="text-align: center">
              @if (map.content.scans[img.id].license) {
                <strong>
                  @if (map.content.scans[img.id].license === mapLicense['CC0']) {
                    <a href="https://creativecommons.org/publicdomain/zero/1.0/" target="_blank">
                      {{ getLicenseLabel(map.content.scans[img.id]) }}
                    </a>
                    <picture>
                      <source
                        srcset="/assets/creative-commons-zero-dark.svg"
                        media="(prefers-color-scheme: dark)"
                      />
                      <img alt="CC0 icon" src="/assets/creative-commons-zero.svg" />
                    </picture>
                  } @else if (isPublicDomain(map.content.scans[img.id])) {
                    <a href="https://creativecommons.org/publicdomain/mark/1.0/" target="_blank">
                      {{ getLicenseLabel(map.content.scans[img.id]) }}
                    </a>
                    <picture>
                      <source
                        srcset="/assets/public-domain-dark.svg"
                        media="(prefers-color-scheme: dark)"
                      />
                      <img alt="public domain icon" src="/assets/public-domain.svg" />
                    </picture>
                  } @else if (map.content.scans[img.id].license === mapLicense['CC-BY']) {
                    <a href="https://creativecommons.org/licenses/by/4.0/deed.en" target="_blank">
                      {{ getLicenseLabel(map.content.scans[img.id]) }}
                    </a>
                    <picture>
                      <source
                        srcset="/assets/creative-commons-by-dark.svg"
                        media="(prefers-color-scheme: dark)"
                      />
                      <img alt="CC-BY 4.0 icon" src="/assets/creative-commons-by.svg" />
                    </picture>
                  } @else {
                    All Rights Reserved ©
                  }
                  {{ map.content.scans[img.id].publicationYear }}
                  {{ getPublisher() }}
                </strong>
                <hr />
              }
            </p>
            <ul>
              @if (map.content.scans[img.id]) {
                @if (map.content.scans[img.id].publicationYear) {
                  <li>
                    <strong>Published:</strong>
                    {{ map.content.scans[img.id].publicationYear }}
                  </li>
                }
                @if (map.content.scans[img.id].publicationCountry) {
                  <li>
                    <strong>Country:</strong>
                    {{ map.content.scans[img.id].publicationCountry }}
                  </li>
                }
                @if (map.content.scans[img.id].publicationPlace) {
                  <li>
                    <strong>Place:</strong>
                    {{ map.content.scans[img.id].publicationPlace }}
                  </li>
                }
                @if (
                  map.content.scans[img.id].languages &&
                  (map.content.scans[img.id].languages || []).length > 0
                ) {
                  <li>
                    <strong>Languages:</strong>
                    {{ (map.content.scans[img.id].languages || []).join(', ') }}
                  </li>
                }
                @if (map.content.scans[img.id].code) {
                  <li>
                    <strong>Code:</strong>
                    {{ map.content.scans[img.id].code }}
                  </li>
                }
                @if (map.content.scans[img.id].license) {
                  <li>
                    <strong>Original License:</strong>
                    {{ map.content.scans[img.id].license }}
                  </li>
                }
              }
            </ul>
          }
        </mat-card-content>
        <mat-card-actions>
          <a
            style="width: 100%"
            mat-button
            target="_blank"
            download="{{ img.filename }}"
            rel="noopener norefferer"
            href="{{ kinko }}/dataset/{{ img.datasetId }}/attachment/{{ img.id }}/_blob"
          >
            <mat-icon>download</mat-icon>
            Original Scan - {{ img.byteSize | humanReadableSize }}
          </a>
        </mat-card-actions>
      </mat-card>
    }
  </div>

  <!-- Image Paginator -->

  <p>
    <mat-paginator
      showFirstLastButtons
      (page)="imagePageChange($event)"
      [length]="imageList.value()?.count"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[defaultPageSize, 24, 48]"
    ></mat-paginator>
  </p>

  <!-- Card with Leaflet map showing geographical coverage -->
  @if (map.content.geojson; as geometry) {
    <h2>Geographical Coverage</h2>
    <mat-card appearance="outlined" class="npdc-leaflet">
      <app-leaflet-group [geometry]="geometry"></app-leaflet-group>
    </mat-card>

    <p>
      <strong>Note: </strong>The indicated geographical coverage might not exactly match those of
      the map(s). The main purpose is to provide a quick reference of where on earth the areas
      depicted are located.
    </p>
  }

  <!-- Summary -->

  <div>
    <h2>Summary</h2>
    <div class="npdc-markdown" [innerHtml]="map.content.summary | markdown"></div>
  </div>

  <!-- Contributors -->

  @if (map.content.contributors && map.content.contributors.length > 0) {
    <div>
      <h2>Contributors</h2>
      @for (contrib of map.content.contributors; track contrib.name) {
        <mat-list-item>
          <mat-icon matListItemIcon>people</mat-icon>
          <div matListItemTitle>{{ contrib.name }}</div>
          @if (contrib.email) {
            <div matListItemLine>
              <strong>Email:</strong>
              {{ contrib.email }}
            </div>
          }
          <div matListItemLine>
            <strong>Roles:</strong>
            {{ contrib.roles.join(', ') }}
          </div>
        </mat-list-item>
      }
    </div>
  }

  <!-- Organisations -->

  @if (map.content.organisations && map.content.organisations.length > 0) {
    <div>
      <h2>Organisations</h2>
      <mat-list>
        @for (org of map.content.organisations; track org.name) {
          <mat-list-item>
            <mat-icon matListItemIcon>source_environment</mat-icon>
            <div matListItemTitle>{{ org.name }}</div>
            @if (org.url) {
              <div matListItemLine>
                <strong>Webpage: </strong>
                <a href="{{ org.url }}" target="_blank">{{ org.url }}</a>
              </div>
            }
            <div matListItemLine>
              <strong>Roles:</strong>
              {{ org.roles.join(', ') }}
            </div>
            <div matListItemMeta>
              @if (org.roles.includes(orgRole['Archive'])) {
                @if (authService.user() && permissions()?.mayUpdate) {
                  <span [matTooltip]="getArchiveInfo(org)">
                    <mat-icon>info</mat-icon>
                  </span>
                }
              }
            </div>
          </mat-list-item>
        }
      </mat-list>
    </div>
  }
}
